<template>
  <footer class="footer footer_bg_1">
    <div class="footer_top">
      <div class="container">
        <div class="row">
          <div class="col-xl-4 col-md-6 col-lg-4">
            <div class="footer_widget">
              <div class="footer_logo">
                <a href="#">
                  <img src="@/assets/images/logo.png" alt="" />
                </a>
              </div>
              <p>
                华儿街及OneCode是湖南暴雪文化科技公司旗下青少年科创活动及学习品牌。
              </p>
            </div>
          </div>
          <div class="col-xl-2 offset-xl-1 col-md-6 col-lg-3">
            <div class="footer_widget">
              <h3 class="footer_title">课程体系</h3>
              <ul>
                <li><a href="#">编程计算思维</a></li>
                <li><a href="#">机器人技术</a></li>
                <li><a href="#">学龄前动手启智</a></li>
                <li><a href="#">自然科学</a></li>
                <li><a href="#">竞赛考级</a></li>
              </ul>
            </div>
          </div>
          <div class="col-xl-2 col-md-6 col-lg-2">
            <div class="footer_widget">
              <h3 class="footer_title">资源</h3>
              <ul>
                <li><a href="#">线下场馆</a></li>
                <li><a href="#">OneCode学习平台</a></li>
                <li><a href="#">3D搭建图纸</a></li>
                <li><a href="#">OJ在线判题系统</a></li>
                <li><a href="#">腾讯视频号</a></li>
              </ul>
            </div>
          </div>
          <div class="col-xl-2 col-md-6 col-lg-2">
            <div class="footer_widget">
              <h3 class="footer_title">友情链接</h3>
              <ul>
                <li>
                  <a href="https://gesp.ccf.org.cn/" target="_blank"
                    >中国计算机学会GESP</a
                  >
                </li>
                <li>
                  <a href="https://www.Creaticode.com" target="_blank"
                    >CreatiCode3D编程</a
                  >
                </li>
                <li>
                  <a
                    href="https://mp.weixin.qq.com/s/hkcr7a5VbKqdDWhbfM6K7Q"
                    target="_blank"
                    >宏宇小学信息技术中心</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.10086.cn/index/hn/index_731_745.html"
                    target="_blank"
                    >中国移动怀化分公司</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy-right_text">
      <div class="container">
        <div class="footer_border"></div>
        <div class="row">
          <div class="col-xl-12">
            <p class="copy_right text-center">
              Copyright &copy; 2022 官方网站版权所有CIP备案：
              湘ICP备2021021249号
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  setup() {},
});
</script>
